import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { PartnerSwitcherComponent } from './partner-switcher.component';
import { PartnerSwitcherService } from './partner-switcher.service';
import { GalaxyInfiniteScrollTriggerModule } from '@vendasta/galaxy/infinite-scroll-trigger';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';

const MatModules = [MatButtonModule, MatDialogModule, MatInputModule, MatListModule];

@NgModule({
  imports: [
    MatModules,
    CommonModule,
    GalaxyFormFieldModule,
    GalaxyInfiniteScrollTriggerModule,
    GalaxyLoadingSpinnerModule,
  ],
  declarations: [PartnerSwitcherComponent],
  providers: [PartnerSwitcherService],
  exports: [],
})
export class PartnerSwitcherModule {}
